import { Link } from 'react-router-dom';
import { getWorksByType } from '@/utils/content';

const entries = [
  {
    type: 'movie',
    label: '电影',
    icon: 'ri-movie-2-line',
    desc: '院线与口碑佳作',
  },
  {
    type: 'tv',
    label: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '连载与完结剧集',
  },
  {
    type: 'variety',
    label: '综艺',
    icon: 'ri-mic-line',
    desc: '美食音乐与旅行',
  },
];

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-400 hover:bg-background-50"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950 md:h-16 md:w-16">
              <i className={`${entry.icon} text-2xl md:text-3xl`} aria-hidden="true" />
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-base font-bold text-foreground-950">{entry.label}</h3>
              <p className="mt-1 text-xs text-secondary-500">{entry.desc}</p>
              <p className="mt-2 flex items-center gap-1 text-xs font-medium text-accent-600">
                共 {getWorksByType(entry.type).length} 部作品
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}